<template>
  <div>
    <a-card title="工单关键词录入">
      <a slot="extra" @click="modalShow">添加</a>
      <div>
        <a-tag v-for="word in ticketWords" :key="word.id" class="tag" style="margin-right: 5px">{{ word.title }}</a-tag>
      </div>
    </a-card>
    <a-modal v-model="modalVisible" title="新增关键词" @ok="handleOk">
      <a-input v-model="newWord" placeholder="请输入词语" style="width: 300px" />
    </a-modal>
  </div>
</template>

<script>
import { userList } from '@/api/system/auth';
import { getAllTicketWord, addWord } from '@/api/event/problem';
export default {
  data() {
    return {
      ticketWords: null,
      loading: false,
      isVisible: false,
      newWord: '',
      fatherId: 0,
      tagName: '',
      modalVisible: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'key',
          key: 'key',
          width: 70,
          scopedSlots: { customRender: 'key' }
        },
        {
          title: '父级名称',
          dataIndex: 'title',
          key: 'title',
          width: 140,
          scopedSlots: { customRender: 'title' }
        },
        {
          title: '工单类型',
          dataIndex: 'children',
          key: 'children',
          scopedSlots: { customRender: 'children' }
        },
        {
          title: '操作',
          key: 'action',
          width: 70,
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },
  mounted() {
    this.getConfigList();
  },
  methods: {
    modalShow(id) {
      this.newWord = '';
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    handleOk() {
      if (this.newWord !== '') {
        this.loading = true;
        addWord({ word: this.newWord })
          .then(res => {
            this.loading = false;
            if (res.data.success === false) {
              alert(res.data.message);
            } else {
              this.modalVisible = false;
              this.getConfigList();
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getConfigList() {
      this.loading = true;
      getAllTicketWord()
        .then(res => {
          this.ticketWords = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
